import { get } from 'lodash';

import * as TransferApi from '@/api/bill/transfer';
import actionTypes from './actionType';

const toggleTransferModalVisible = (visible) => {
  return {
    type: actionTypes.TOGGLE_TRANSFER_MODAL_VISIBLE,
    payload: {
      modalVisible: visible,
    },
  };
};

const setTargetRoomsLoading = (loading) => {
  return {
    type: actionTypes.SET_TARGETS_LOADING,
    payload: {
      roomsLoading: loading,
    },
  };
};

const initTransferTargets = () => {
  return async (dispatch) => {
    dispatch(setTargetRoomsLoading(true));
    try {
      const res = await TransferApi.fetchTransferTargets();
      dispatch(setTargetRoomsLoading(false));

      const sourceData = get(res, 'data', []);
      // extract all rooms
      const allRooms = sourceData.reduce((prev, cur) => {
        return Array.prototype.concat.call(prev, cur.roomList);
      }, []);

      dispatch({
        type: actionTypes.SET_TARGET_ROOMS,
        payload: {
          rooms: allRooms,
        },
      });
      dispatch({
        type: actionTypes.SET_TARGET_ROOMTYPES,
        payload: {
          roomTypes: sourceData,
        },
      });
    } catch (err) {
      dispatch(setTargetRoomsLoading(false));
    }
  };
};

const resetTargets = () => {
  return {
    type: actionTypes.RESET_TARGETS,
    payload: {},
  };
};

const setSelectedTargetRoom = (room) => {
  return {
    type: actionTypes.SET_SELECTED_TARGET_ROOM,
    payload: {
      selectedRoom: room,
    },
  };
};

const setSelectedTargetRoomId = (roomId) => {
  return {
    type: actionTypes.SET_SELECTED_TARGET_ROOM_ID,
    payload: {
      selectedRoomId: roomId,
    },
  };
};

export {
  toggleTransferModalVisible,
  setTargetRoomsLoading,
  initTransferTargets,
  resetTargets,
  setSelectedTargetRoom,
  setSelectedTargetRoomId,
};
